<template>
  <div>
    <QuestionHeader />

    <section class="mla-list-sec">
      <div class="container">
        <!-- 🔹 Breadcrumb -->
        <div class="breadcrumb-wrapper visible">
          <div class="breadcrumb">
            <span
              class="breadcrumb-item"
              :class="{ active: activeSection === 'MLA CONTENT MAP' }"
              @click="activeSection = 'MLA CONTENT MAP'"
            >
              MLA content map
            </span>
            <span class="breadcrumb-arrow" v-if="showAreaBreadcrumbs">›</span>

            <!-- BY AREAS + BY CONDITIONS (only when showAreaBreadcrumbs is true) -->
            <template v-if="showAreaBreadcrumbs">
              <span
                class="breadcrumb-item"
                :class="{ active: activeSection === 'BY AREAS' }"
                @click="activeSection = 'BY AREAS'"
              >
                <!-- By areas -->
                Areas
              </span>
              <!-- <span class="breadcrumb-arrow">›</span>
          <span class="breadcrumb-item" :class="{ active: activeSection === 'BY CONDITIONS' }"
            @click="activeSection = 'BY CONDITIONS'">
            BY CONDITIONS
          </span> -->
            </template>

            <!-- PRESENTATIONS AND CONDITIONS + ALPHABETICALLY (only when showPresentationBreadcrumbs is true) -->
            <template v-if="showPresentationBreadcrumbs">
              <span class="breadcrumb-arrow">›</span>
              <span
                class="breadcrumb-item"
                :class="{
                  active:
                    activeSection === 'PRESENTATIONS AND CONDITIONS' ||
                    activeSection === 'ALPHABETICALLY',
                }"
                @click="activeSection = 'PRESENTATIONS AND CONDITIONS'"
              >
                Presentations and Conditions
              </span>

              <span
                v-if="activeSection === 'BY AREAS PRESENTATION'"
                class="breadcrumb-item"
                :class="{
                  active:
                    activeSection === 'BY AREAS PRESENTATION' && activeSubSection == '',
                }"
                @click="activeSection = 'BY AREAS PRESENTATION'"
              >
                By areas
              </span>
              <span
                v-if="
                  activeSection === 'BY AREAS PRESENTATION' &&
                  activeSubSection == 'ByAreaCondition'
                "
                class="breadcrumb-arrow"
                >›</span
              >
              <span
                v-if="
                  activeSection === 'BY AREAS PRESENTATION' &&
                  activeSubSection == 'ByAreaCondition'
                "
                class="breadcrumb-item"
                :class="{ active: activeSection === 'BY AREAS PRESENTATION' }"
                @click="activeSection = 'BY AREAS PRESENTATION'"
              >
                Abdominal distension
              </span>
            </template>
          </div>
        </div>

        <!-- 🔹 Content -->
        <div
          class="mla-list-layout"
          :class="{ 'mla-list-layout--sidebar-collapsed': leftPanelCollapsed }"
        >
          <div class="mlalist-left-section">
            <div
              class="mlalist-left-full"
              :class="{ 'mlalist-left-full--hidden': leftPanelCollapsed }"
            >
              <div
                @mouseenter="showBreadcrumb = true"
                @mouseleave="showBreadcrumb = false"
              >
                <MLAContentMap
                  :viewMode="viewMode"
                  @set-view-mode="setViewMode"
                  @sort-changed="handleSortChange"
                  @update-active-section="activeSection = $event"
                />
                <SidebarSearchBox
                  v-model="searchQuery"
                  theme="questions"
                  @search="openSearch"
                />
              </div>
              <div>
                <div class="questions-notes-mocks">
                  <div
                    class="mla-question-box"
                    :class="{ 'is-section-locked': isSectionLocked('questions') }"
                    :style="{ cursor: isSectionLocked('questions') ? 'not-allowed' : 'pointer' }"
                    :title="isSectionLocked('questions') ? 'Locked Section' : 'Click to switch between Progress and Score'"
                    @click="onQuestionsSidebarClick"
                  >
                    <SectionLockBadge v-if="isSectionLocked('questions')" />
                    <div class="section-card-body">
                      <h4><img src="/images/questionmark.png" alt="img" /> Questions</h4>
                      <ProgressBar
                        v-if="!isSectionLocked('questions')"
                        :progress="
                          questionsSidebarScoreMode
                            ? globalScorePercent
                            : globalProgressPercent
                        "
                        :label="questionsSidebarScoreMode ? 'Score' : 'Progress'"
                        :mode="questionsSidebarScoreMode ? 'score' : 'progress'"
                        :detail="questionsSidebarDetail"
                      />
                    </div>
                    <div class="cardbottom-shadow">
                      <img src="/images/cardshadow.png" alt="" />
                    </div>
                  </div>
                  <div
                    class="mla-question-box mla-note-box"
                    :class="{ 'is-section-locked': isSectionLocked('notes') }"
                    :style="{ cursor: isSectionLocked('notes') ? 'not-allowed' : 'pointer' }"
                    :title="isSectionLocked('notes') ? 'Locked Section' : ''"
                    @click="openExitAlert('Notes')"
                  >
                    <SectionLockBadge v-if="isSectionLocked('notes')" />
                    <div class="section-card-body">
                      <h4><img src="/images/file.png" alt="img" /> Notes</h4>
                      <ProgressBar
                        v-if="!isSectionLocked('notes')"
                        :progress="notesProgressPercent"
                        label="Progress"
                        :detail="notesProgressDetail"
                      />
                    </div>
                    <div class="cardbottom-shadow">
                      <img src="/images/cardshadow.png" alt="" />
                    </div>
                  </div>
                  <div
                    class="mla-question-box mla-mock-box"
                    :class="{ 'is-section-locked': isSectionLocked('mocks') }"
                    :style="{ cursor: isSectionLocked('mocks') ? 'not-allowed' : 'pointer' }"
                    :title="isSectionLocked('mocks') ? 'Locked Section' : ''"
                    @click="openExitAlert('Mocks')"
                  >
                    <SectionLockBadge v-if="isSectionLocked('mocks')" />
                    <div class="section-card-body">
                      <h4>
                        <img src="/images/brain.png" alt="img" /> Mocks
                      </h4>
                      <ProgressBar
                        v-if="!isSectionLocked('mocks')"
                        :progress="mocksProgressPercent"
                        label="Progress"
                        mode="progress"
                        :detail="mocksProgressDetail"
                      />
                    </div>
                    <div class="cardbottom-shadow">
                      <img src="/images/cardshadow.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <aside
              v-if="leftPanelCollapsed"
              class="mla-collapsed-rail"
              aria-label="Collapsed sidebar"
            >
              <button
                type="button"
                class="mla-collapsed-rail-toggle"
                title="Show sidebar"
                aria-label="Show sidebar"
                @click="toggleLeftPanel"
              >

              <svg width="13" height="29" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.28012 6.31402L2.05011 0.473996C1.91038 0.278017 1.71173 0.131779 1.48309 0.0565768C1.25445 -0.0186254 1.00774 -0.0188673 0.778956 0.0559054C0.550174 0.130678 0.351243 0.276571 0.211146 0.472287C0.0710492 0.668004 -0.00289455 0.903306 8.67349e-05 1.14398V12.814C-0.00289455 13.0547 0.0710492 13.29 0.211146 13.4857C0.351243 13.6814 0.550174 13.8273 0.778956 13.9021C1.00774 13.9769 1.25445 13.9766 1.48309 13.9014C1.71173 13.8262 1.91038 13.68 2.05011 13.484L6.28012 7.64398C6.42075 7.45077 6.49649 7.21797 6.49649 6.979C6.49649 6.74003 6.42075 6.50723 6.28012 6.31402Z" fill="white"/>
</svg>

                <!-- <svg
                  class="mla-sidebar-toggle-tab mla-sidebar-toggle-tab--expand"
                  viewBox="0 0 16 32"
                  aria-hidden="true"
                >
                  <defs>
                    <linearGradient
                      id="mlaSidebarToggleGradHover"
                      x1="0"
                      y1="0.5"
                      x2="1"
                      y2="0.5"
                    >
                      <stop offset="0%" stop-color="#b0ddf9" />
                      <stop offset="45%" stop-color="#8ecbf5" />
                      <stop offset="100%" stop-color="#79c0eb" />
                    </linearGradient>
                  </defs>
                  <path
                    d="M1.5 9.2v13.6c0 4 3.2 5.6 5.8 3.6L12.8 19c2.8-2.2 2.8-5.8 0-8L7.3 5.6C4.7 3.6 1.5 5.2 1.5 9.2z"
                  />
                </svg> -->
              </button>
              <div class="mla-collapsed-rail-body">
                <div class="mla-collapsed-rail-segment mla-collapsed-rail-segment--map">
                  <span class="mla-collapsed-rail-label">MLA content map</span>
                </div>
                <div
                  class="mla-collapsed-rail-segment mla-collapsed-rail-segment--questions"
                  title="Questions"
                ></div>
                <div
                  class="mla-collapsed-rail-segment mla-collapsed-rail-segment--gap"
                ></div>
                <div
                  class="mla-collapsed-rail-segment mla-collapsed-rail-segment--notes"
                  title="Notes"
                ></div>
                <div
                  class="mla-collapsed-rail-segment mla-collapsed-rail-segment--gap"
                ></div>
                <div
                  class="mla-collapsed-rail-segment mla-collapsed-rail-segment--mocks"
                  title="Mocks"
                ></div>
              </div>
            </aside>
          </div>

          <div class="mlalist-right-section">
            <button
              v-if="!leftPanelCollapsed"
              type="button"
              class="mla-sidebar-toggle"
              title="Hide sidebar"
              aria-label="Hide sidebar"
              :aria-expanded="true"
              @click="toggleLeftPanel"
            >
              <svg
                width="13"
                height="29"
                viewBox="0 0 13 29"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.355042 15.2902L9.35504 27.7003C9.58009 28.0074 9.89627 28.2357 10.2586 28.3528C10.6209 28.4699 11.0109 28.4697 11.3732 28.3522C11.7354 28.2348 12.0514 28.0062 12.2761 27.6988C12.5009 27.3914 12.623 27.021 12.6251 26.6403V1.80024C12.623 1.41947 12.5009 1.04902 12.2761 0.741647C12.0514 0.434275 11.7354 0.205622 11.3732 0.0882047C11.0109 -0.0292126 10.6209 -0.0294068 10.2586 0.0876554C9.89627 0.204718 9.58009 0.433092 9.35504 0.740243L0.355042 13.1502C0.124547 13.4593 0 13.8346 0 14.2202C0 14.6058 0.124547 14.9811 0.355042 15.2902Z"
                  fill="url(#paint0_linear_3767_1060)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_3767_1060"
                    x1="0.0150088"
                    y1="14.2402"
                    x2="12.6051"
                    y2="14.2402"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#1A90FF" />
                    <stop
                      offset="0.269284"
                      stop-color="#3DA1FF"
                      stop-opacity="0.846107"
                    />
                    <stop offset="1" stop-color="#EBF6FF" />
                  </linearGradient>
                </defs>
              </svg>

              <!-- <svg class="mla-sidebar-toggle-tab" viewBox="0 0 16 32" aria-hidden="true">
                <defs>
                  <linearGradient id="mlaSidebarToggleGrad" x1="1" y1="0.5" x2="0" y2="0.5">
                    <stop offset="0%" stop-color="#b0ddf9" />
                    <stop offset="45%" stop-color="#8ecbf5" />
                    <stop offset="100%" stop-color="#79c0eb" />
                  </linearGradient>
                  <linearGradient id="mlaSidebarToggleGradHover" x1="1" y1="0.5" x2="0" y2="0.5">
                    <stop offset="0%" stop-color="#b0ddf9" />
                    <stop offset="45%" stop-color="#8ecbf5" />
                    <stop offset="100%" stop-color="#79c0eb" />
                  </linearGradient>
                </defs>
                <path fill="url(#mlaSidebarToggleGrad)" d="M14.5 9.2v13.6c0 4-3.2 5.6-5.8 3.6L3.2 19c-2.8-2.2-2.8-5.8 0-8L8.7 5.6C11.3 3.6 14.5 5.2 14.5 9.2z" />
              </svg> -->
            </button>
            <template v-if="activeSection === 'MLA CONTENT MAP'"></template>
            <template v-if="activeSection === 'BY AREAS'">
              <div
                class="listing"
                @mouseenter="showBreadcrumb = true"
                @mouseleave="showBreadcrumb = false"
              >
                <MLASubList
                  title="Areas of clinical practice"
                  :total="clinicalTotal"
                  :items="clinicalAreas"
                  wrapperClass="areas-clinical-practice"
                  :show-score-detail="questionsSidebarScoreMode"
                />
                <MLASubList
                  title="Areas of professional knowledge"
                  :total="professionalTotal"
                  :items="professionalKnowledge"
                  wrapperClass="areas-professional-knowledge"
                  :show-score-detail="questionsSidebarScoreMode"
                />
              </div>
            </template>

            <!-- <template v-else-if="activeSection === 'BY CONDITIONS'">
            <MLAList title="Conditions List (Example)" total="0/1200" :items="conditionsList"
              wrapperClass="full-width-list" />
          </template> -->
            <!-- <template v-if="activeSection === 'PRESENTATIONS AND CONDITIONS'"></template> -->
            <template v-if="activeSection === 'ALPHABETICALLY'">
              <div
                class="listing"
                @mouseenter="showBreadcrumb = true"
                @mouseleave="showBreadcrumb = false"
              >
                <MLAList
                  title="Presentations"
                  :total="presentationsTotal"
                  :items="PresentationsList"
                  wrapperClass="areas-clinical-practice"
                  :show-score-detail="questionsSidebarScoreMode"
                />
                <MLASubList
                  title="Conditions"
                  :total="conditionsTotal"
                  :items="AlphaConditionsList"
                  wrapperClass="areas-professional-knowledge"
                  :show-score-detail="questionsSidebarScoreMode"
                  list-section="ALPHABETICALLY"
                />
              </div>
            </template>

            <div v-if="showExitPopup" class="overlay">
              <div class="popup">
                <p>Are you sure you want to exit question screen?</p>

                <div class="actions">
                  <button class="yes" @click="confirmExit">Yes</button>
                  <button class="no" @click="showExitPopup = false">No</button>
                </div>
              </div>
            </div>

            <SectionSubscribeModal
              :open="showSubscribePopup"
              :message="subscribeMessage"
              @close="showSubscribePopup = false"
            />

            <!-- <template v-if="activeSection === 'BY AREAS PRESENTATION' && activeSubSection == ''">
            <div class="listing"
            @mouseenter="showBreadcrumb = true"
            @mouseleave="showBreadcrumb = false">
            <MLAList title="Presentations / Condition" total="0/974" :items="presentationcondition"
              wrapperClass="areas-presentation-condition" condition="conditionAreas" @AreaCondition="AreaCondition" />
            </div>
            
          </template> -->

            <!-- <template v-if="activeSection === 'BY AREAS PRESENTATION' && activeSubSection == 'ByAreaCondition'">
            <div class="listing"
            @mouseenter="showBreadcrumb = true"
            @mouseleave="showBreadcrumb = false">
            <MLAList title="Presentations" total="0/974" :items="PresentationsList"
              wrapperClass="areas-clinical-practice" />
            <MLASubList title="Conditions" total="0/1140" :items="AlphaConditionsList"
            wrapperClass="areas-professional-knowledge" />
            </div>
          </template> -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import QuestionHeader from "@/components/QuestionHeader.vue";
import MLAContentMap from "@/components/MLAContentMap.vue";
import MLAList from "@/components/MLAList.vue";
import MLASubList from "@/components/MLASubList.vue";

import ProgressBar from "@/components/HomepageProgress.vue";
import SectionLockBadge from "@/components/SectionLockBadge.vue";
import SectionSubscribeModal from "@/components/SectionSubscribeModal.vue";
import SidebarSearchBox from "@/components/SidebarSearchBox.vue";
import { get } from "./lib/api";
import {
  mocksAggregateProgressPercent,
  mocksAggregateTotals,
} from "./lib/mocksAggregate";
import {
  hydrateNoteUserState,
  invalidateNotesPrefsCache,
  notesProgressStats,
  rebuildNotesNumberRegistry,
} from "./lib/notesUserPrefs";
import { emptySectionLocks, fetchSectionLocks, subscribeSectionMessage } from "./lib/sectionLocks";

export default {
  name: "MLAListSelection",
  components: {
    QuestionHeader,
    MLAContentMap,
    ProgressBar,
    SectionLockBadge,
    SectionSubscribeModal,
    SidebarSearchBox,
    MLAList,
    MLASubList,
  },
  data() {
    return {
      exitpage: "",
      showExitPopup: false,
      showSubscribePopup: false,
      subscribeMessage: "",
      searchQuery: "",
      activeSection: "BY AREAS",
      activeSubSection: "",
      viewMode: "areas",
      showBreadcrumb: false,
      leftPanelCollapsed: false,
      /** false = Progress (default), true = Score — toggled by clicking the Questions card */
      questionsSidebarScoreMode: false,
      clinicalAreas: [],
      professionalKnowledge: [],
      notesClinicalAreas: [],
      notesProfessionalKnowledge: [],
      notesReadRev: 0,
      mocksData: [],
      sectionLocks: emptySectionLocks(),
      //     clinicalAreas: [
      //       { title: '1. Acute and emergency', progress: '0/134' },
      // //       {
      // //   title: '1. Acute and emergency',
      // //   progress: '0/134',
      // //   children: [
      // //     {
      // //       title: 'Acid-base abnormality',
      // //       questions: [1, 2, 3, 4, 5]
      // //     },
      // //     {
      // //       title: 'Acute bronchitis',
      // //       questions: [6, 7]
      // //     },
      // //     {
      // //       title: 'Acute coronary syndromes',
      // //       children: [
      // //         { title: 'STEMI', questions: [8] },
      // //         { title: 'NSTEMI', questions: [9, 10, 11] }
      // //       ]
      // //     },
      // //     {
      // //       title: 'Acute kidney injury',
      // //       children: [
      // //         { title: 'Acute kidney injury', questions: [12] },
      // //         { title: 'Rhabdomyolysis', questions: [13] },
      // //         { title: 'Acute interstitial nephritis', questions: [14] },
      // //         { title: 'Hemolytic uremic syndrome', questions: [15] }
      // //       ]
      // //     },
      // //     {
      // //       title: 'Allergic disorder',
      // //       children: [
      // //         { title: 'Anaphylaxis', questions: [16] },
      // //         { title: 'Contact dermatitis', questions: [17] },
      // //         { title: 'Food allergy', questions: [18] },
      // //         { title: 'Urticaria', questions: [19] }
      // //       ]
      // //     },
      // //     {
      // //       title: 'Anaphylaxis',
      // //       questions: [20, 21]
      // //     },
      // //     {
      // //       title: 'Aortic aneurysm',
      // //       questions: [22, 23]
      // //     },
      // //     {
      // //       title: 'Arrhythmias',
      // //       children: [
      // //         { title: 'Atrial fibrillation', questions: [24] },
      // //         { title: 'Heart block', questions: [25] },
      // //         { title: 'Long QT syndrome', questions: [26] },
      // //         { title: 'Supraventricular tachycardia', questions: [27] }
      // //       ]
      // //     },
      // //     {
      // //       title: 'Cardiac arrest',
      // //       questions: [28, 29]
      // //     },
      // //     {
      // //       title: 'Cardiac failure',
      // //       questions: [30, 31]
      // //     },
      // //     {
      // //       title: 'Chronic obstructive pulmonary disease',
      // //       questions: [32, 33]
      // //     },
      // //     {
      // //       title: 'Compartment syndrome',
      // //       questions: [34, 35]
      // //     },
      // //     {
      // //       title: 'Deep vein thrombosis',
      // //       questions: [36, 37]
      // //     },
      // //     {
      // //       title: 'Dehydration',
      // //       questions: [38, 39]
      // //     },
      // //     {
      // //       title: 'Diabetic ketoacidosis',
      // //       questions: [40, 41]
      // //     },
      // //     {
      // //       title: 'Drug overdose',
      // //       children: [
      // //         { title: 'Aspirin', questions: [42] },
      // //         { title: 'Cocaine', questions: [43] },
      // //         { title: 'Lithium', questions: [44] },
      // //         { title: 'MDMA', questions: [45] },
      // //         { title: 'Neuroleptic malignant syndrome', questions: [46] },
      // //         { title: 'Opioid overdose and withdrawal', questions: [47] },
      // //         { title: 'Paracetamol overdose and withdrawal', questions: [48] },
      // //         { title: 'Serotonin syndrome', questions: [49] },
      // //         { title: 'TCA', questions: [50] }
      // //       ]
      // //     },
      // //     {
      // //       title: 'Ectopic pregnancy',
      // //       questions: [51, 52]
      // //     },
      // //     {
      // //       title: 'Epilepsy',
      // //       children: [
      // //         { title: 'Epilepsy', questions: [53] },
      // //         { title: 'Infantile spasm', questions: [54] },
      // //         { title: 'Non-epileptic attack disorder', questions: [55] }
      // //       ]
      // //     },
      // //     {
      // //       title: 'Epistaxis',
      // //       questions: [56, 57]
      // //     },
      // //     {
      // //       title: 'Extradural haemorrhage',
      // //       questions: [58, 59]
      // //     },
      // //     {
      // //       title: 'Gastrointestinal perforation',
      // //       children: [
      // //         { title: 'Oesophageal perforation', questions: [60] }
      // //       ]
      // //     },
      // //     {
      // //       title: 'Haemoglobinopathies',
      // //       children: [
      // //         { title: 'Thalassaemia', questions: [61, 62] },
      // //         { title: 'Sickle cell disease', questions: [63] }
      // //       ]
      // //     },
      // //     {
      // //       title: 'Hyperosmolar hyperglycaemic state',
      // //       questions: [64, 65]
      // //     },
      // //     {
      // //       title: 'Hyperthermia and hypothermia',
      // //       children: [
      // //         { title: 'Hypothermia', questions: [66] },
      // //         { title: 'Malignant hyperthermia', questions: [67] }
      // //       ]
      // //     },
      // //     {
      // //       title: 'Meningitis',
      // //       questions: [68, 69]
      // //     },
      // //     {
      // //       title: 'Myocardial infarction',
      // //       questions: [70, 71]
      // //     },
      // //     {
      // //       title: 'Necrotising fasciitis',
      // //       questions: [72, 73]
      // //     },
      // //     {
      // //       title: 'Non-accidental injury',
      // //       children: [
      // //         { title: 'Child abuse', questions: [74] },
      // //         { title: 'Adult abuse', questions: [75] }
      // //       ]
      // //     },
      // //     {
      // //       title: 'Pancytopenia',
      // //       questions: [76, 77]
      // //     },
      // //     {
      // //       title: 'Pneumonia',
      // //       questions: [78, 79]
      // //     },
      // //     {
      // //       title: 'Pneumothorax',
      // //       questions: [80, 81]
      // //     },
      // //     {
      // //       title: 'Postpartum haemorrhage',
      // //       questions: [82, 83]
      // //     },
      // //     {
      // //       title: 'Pulmonary embolism',
      // //       questions: [84, 85]
      // //     },
      // //     {
      // //       title: 'Raised intracranial pressure',
      // //       questions: [86, 87]
      // //     },
      // //     {
      // //       title: 'Respiratory arrest',
      // //       children: [
      // //         { title: 'Adult', questions: [88] },
      // //         { title: 'Child', questions: [89] }
      // //       ]
      // //     },
      // //     {
      // //       title: 'Respiratory failure',
      // //       children: [
      // //         { title: 'Respiratory failure', questions: [90] },
      // //         { title: 'Carbon monoxide poisoning', questions: [91] }
      // //       ]
      // //     },
      // //     {
      // //       title: 'Self-harm',
      // //       questions: [92, 93]
      // //     },
      // //     {
      // //       title: 'Sepsis',
      // //       questions: [94, 95]
      // //     },
      // //     {
      // //       title: 'Spinal cord compression',
      // //       questions: [96, 97]
      // //     },
      // //     {
      // //       title: 'Spinal cord injury',
      // //       questions: [98, 99]
      // //     },
      // //     {
      // //       title: 'Stroke',
      // //       questions: [100, 101]
      // //     },
      // //     {
      // //       title: 'Subarachnoid haemorrhage',
      // //       questions: [102, 103]
      // //     },
      // //     {
      // //       title: 'Subdural haemorrhage',
      // //       questions: [104, 105]
      // //     },
      // //     {
      // //       title: 'Substance use disorder',
      // //       questions: [106, 107]
      // //     },
      // //     {
      // //       title: 'Testicular torsion',
      // //       questions: [108, 109]
      // //     },
      // //     {
      // //       title: 'Toxic shock syndrome',
      // //       questions: [110, 111]
      // //     },
      // //     {
      // //       title: 'Transfusion reactions',
      // //       questions: [114, 115]
      // //     },
      // //     {
      // //       title: 'Unstable angina',
      // //       questions: [116, 117]
      // //     }
      // //   ]
      // // },
      //       { title: '2. Cancer', progress: '0/45' },
      //       { title: '3. Cardiovascular', progress: '0/143' },
      //       { title: '4. Childhealth', progress: '0/54' },
      //       { title: '5. Clinical haematology', progress: '0/110' },
      //       { title: '6. Clinical imaging', progress: '0/45' },
      //       { title: '7. Dermatology', progress: '0/80' },
      //       { title: '8. Ear, nose and throat', progress: '0/78' },
      //       { title: '9. Endocrine and metabolic', progress: '0/84' },
      //       { title: '10. Gastrointestinal including liver', progress: '0/102' },
      //       { title: '11. General practice and primary healthcare', progress: '0/200' },
      //       { title: '12. Infection', progress: '0/102' },
      //       { title: '13. Medicine of older adult', progress: '0/102' },
      //       { title: '14. Mental health', progress: '0/102' },
      //       { title: '15. Musculoskeletal', progress: '0/102' },
      //       { title: '16. Nerusciences', progress: '0/102' },
      //       { title: '17. Obsetetrics and gynaecology', progress: '0/102' },
      //       { title: '18. Opthalmology', progress: '0/102' },
      //       { title: '19. Palliative and end of life care', progress: '0/102' },
      //       { title: '20. Perioperative medicine and anaesthesia', progress: '0/102' },
      //       { title: '21. Renal and Urlology', progress: '0/102' },
      //       { title: '22. Respiratory', progress: '0/102' },
      //       { title: '23. Sexual Health', progress: '0/102' },
      //       { title: '24. Surgery', progress: '0/102' },
      //       { title: '25. All areas and clinical practice', progress: '0/102' },
      //     ],
      //     professionalKnowledge: [
      //       { title: '1. Allergy and immunology', progress: '0/134' },
      //       { title: '2. Biomedical sciences', progress: '0/80' },
      //       { title: '3. Clinical biochemistry', progress: '0/45' },
      //       { title: '4. Clinical pharmacology and therapeutics', progress: '0/60' },
      //       { title: '5. Genetics and genomics', progress: '0/35' },
      //       { title: '6. Histopathology', progress: '0/45' },
      //       { title: '7. Human factors and quality improvement', progress: '0/30' },
      //       { title: '8. Laboratory haematology', progress: '0/40' },
      //       { title: '9. Medical ethics and law', progress: '0/102' },
      //       { title: '10. Microbiology', progress: '0/40' },
      //       { title: '11. Psychological principles', progress: '0/200' },
      //       { title: '12. Social and population health', progress: '0/30' },
      //     ],
      conditionsList: [
        { title: "1. Diabetes", progress: "0/200" },
        { title: "2. Hypertension", progress: "0/150" },
      ],
      PresentationsList: [
        { title: "1. Abdominal distension", progress: "0/10" },
        { title: "2. Abdominal mass", progress: "0/56" },
        { title: "3. Abnormal cervical smear result", progress: "0/14" },
        { title: "4. Abnormal development/developmental delay", progress: "0/20" },
        { title: "5. Abnormal eating or exercising behavior", progress: "0/13" },
        { title: "6. Abnormal involuntary movements", progress: "0/13" },
        { title: "7. Abnormal urinalysis", progress: "0/18" },
        { title: "8. Acute abdominal pain", progress: "0/20" },
        { title: "9. Acute and chronic pain management", progress: "0/60" },
        { title: "10. Acute change in or loss of vision", progress: "0/10" },
        { title: "11. Acute joint pain/swelling", progress: "0/20" },
        { title: "12. Acute kidney injury", progress: "0/15" },
      ],
      AlphaConditionsList: [
        {
          title: "1. Acid-base abnormality",
          progress: "0/12",
          children: [
            {
              title: "Acute bronchitis",
              questions: [6, 7],
            },
            {
              title: "Acute coronary syndromes",
            },
            {
              title: "Acute kidney injury",
            },
            {
              title: "Allergic disorder",
            },
            {
              title: "Anaphylaxis",
              questions: [20, 21],
            },
            {
              title: "Aortic aneurysm",
              questions: [22, 23],
            },
            {
              title: "Arrhythmias",
            },
            {
              title: "Cardiac arrest",
              questions: [28, 29],
            },
            {
              title: "Cardiac failure",
              questions: [30, 31],
            },
            {
              title: "Chronic obstructive pulmonary disease",
              questions: [32, 33],
            },
            {
              title: "Compartment syndrome",
              questions: [34, 35],
            },
            {
              title: "Deep vein thrombosis",
              questions: [36, 37],
            },
            {
              title: "Dehydration",
              questions: [38, 39],
            },
            {
              title: "Diabetic ketoacidosis",
              questions: [40, 41],
            },
            {
              title: "Drug overdose",
            },
            {
              title: "Ectopic pregnancy",
              questions: [51, 52],
            },
            {
              title: "Epilepsy",
            },
            {
              title: "Epistaxis",
              questions: [56, 57],
            },
            {
              title: "Extradural haemorrhage",
              questions: [58, 59],
            },
            {
              title: "Gastrointestinal perforation",
            },
            {
              title: "Haemoglobinopathies",
            },
            {
              title: "Hyperosmolar hyperglycaemic state",
              questions: [64, 65],
            },
            {
              title: "Hyperthermia and hypothermia",
            },
            {
              title: "Meningitis",
              questions: [68, 69],
            },
            {
              title: "Myocardial infarction",
              questions: [70, 71],
            },
            {
              title: "Necrotising fasciitis",
              questions: [72, 73],
            },
            {
              title: "Non-accidental injury",
            },
            {
              title: "Pancytopenia",
              questions: [76, 77],
            },
            {
              title: "Pneumonia",
              questions: [78, 79],
            },
            {
              title: "Pneumothorax",
              questions: [80, 81],
            },
            {
              title: "Postpartum haemorrhage",
              questions: [82, 83],
            },
            {
              title: "Pulmonary embolism",
              questions: [84, 85],
            },
            {
              title: "Raised intracranial pressure",
              questions: [86, 87],
            },
            {
              title: "Respiratory arrest",
            },
            {
              title: "Respiratory failure",
            },
            {
              title: "Self-harm",
              questions: [92, 93],
            },
            {
              title: "Sepsis",
              questions: [94, 95],
            },
            {
              title: "Spinal cord compression",
              questions: [96, 97],
            },
            {
              title: "Spinal cord injury",
              questions: [98, 99],
            },
            {
              title: "Stroke",
              questions: [100, 101],
            },
            {
              title: "Subarachnoid haemorrhage",
              questions: [102, 103],
            },
            {
              title: "Subdural haemorrhage",
              questions: [104, 105],
            },
            {
              title: "Substance use disorder",
              questions: [106, 107],
            },
            {
              title: "Testicular torsion",
              questions: [108, 109],
            },
            {
              title: "Toxic shock syndrome",
              questions: [110, 111],
            },
            {
              title: "Transfusion reactions",
              questions: [114, 115],
            },
            {
              title: "Unstable angina",
              questions: [116, 117],
            },
          ],
        },
        { title: "2. Acne vulgaris", progress: "0/14" },
        { title: "3. Acoustic neuroma", progress: "0/8" },
        { title: "4. Acute bronchitis", progress: "0/8" },
        { title: "5. Acute cholangitis", progress: "0/6" },
        { title: "6. Acute coronary syndromes", progress: "0/14" },
        { title: "7. Acute glaucoma", progress: "0/6" },
        { title: "8. Acute kidney injury ", progress: "0/20" },
        { title: "9. Acute pancreatitis", progress: "0/12" },
        { title: "10. Acute stress reaction", progress: "0/6" },
        { title: "11. Addisons disease", progress: "0/12" },
        { title: "12. Adverse drug effects", progress: "0/38" },
      ],

      presentationcondition: [
        {
          title: "1. Acute and emergency",
          progress: "0/134",
          children: [
            {
              title: "Acid-base abnormality",
              questions: [1, 2, 3, 4, 5],
            },
            {
              title: "Acute bronchitis",
              questions: [6, 7],
            },
            {
              title: "Acute coronary syndromes",
              children: [
                { title: "STEMI", questions: [8] },
                { title: "NSTEMI", questions: [9, 10, 11] },
              ],
            },
            {
              title: "Acute kidney injury",
              children: [
                { title: "Acute kidney injury", questions: [12] },
                { title: "Rhabdomyolysis", questions: [13] },
                { title: "Acute interstitial nephritis", questions: [14] },
                { title: "Hemolytic uremic syndrome", questions: [15] },
              ],
            },
            {
              title: "Allergic disorder",
              children: [
                { title: "Anaphylaxis", questions: [16] },
                { title: "Contact dermatitis", questions: [17] },
                { title: "Food allergy", questions: [18] },
                { title: "Urticaria", questions: [19] },
              ],
            },
            {
              title: "Anaphylaxis",
              questions: [20, 21],
            },
            {
              title: "Aortic aneurysm",
              questions: [22, 23],
            },
            {
              title: "Arrhythmias",
              children: [
                { title: "Atrial fibrillation", questions: [24] },
                { title: "Heart block", questions: [25] },
                { title: "Long QT syndrome", questions: [26] },
                { title: "Supraventricular tachycardia", questions: [27] },
              ],
            },
            {
              title: "Cardiac arrest",
              questions: [28, 29],
            },
            {
              title: "Cardiac failure",
              questions: [30, 31],
            },
            {
              title: "Chronic obstructive pulmonary disease",
              questions: [32, 33],
            },
            {
              title: "Compartment syndrome",
              questions: [34, 35],
            },
            {
              title: "Deep vein thrombosis",
              questions: [36, 37],
            },
            {
              title: "Dehydration",
              questions: [38, 39],
            },
            {
              title: "Diabetic ketoacidosis",
              questions: [40, 41],
            },
            {
              title: "Drug overdose",
              children: [
                { title: "Aspirin", questions: [42] },
                { title: "Cocaine", questions: [43] },
                { title: "Lithium", questions: [44] },
                { title: "MDMA", questions: [45] },
                { title: "Neuroleptic malignant syndrome", questions: [46] },
                { title: "Opioid overdose and withdrawal", questions: [47] },
                { title: "Paracetamol overdose and withdrawal", questions: [48] },
                { title: "Serotonin syndrome", questions: [49] },
                { title: "TCA", questions: [50] },
              ],
            },
            {
              title: "Ectopic pregnancy",
              questions: [51, 52],
            },
            {
              title: "Epilepsy",
              children: [
                { title: "Epilepsy", questions: [53] },
                { title: "Infantile spasm", questions: [54] },
                { title: "Non-epileptic attack disorder", questions: [55] },
              ],
            },
            {
              title: "Epistaxis",
              questions: [56, 57],
            },
            {
              title: "Extradural haemorrhage",
              questions: [58, 59],
            },
            {
              title: "Gastrointestinal perforation",
              children: [{ title: "Oesophageal perforation", questions: [60] }],
            },
            {
              title: "Haemoglobinopathies",
              children: [
                { title: "Thalassaemia", questions: [61, 62] },
                { title: "Sickle cell disease", questions: [63] },
              ],
            },
            {
              title: "Hyperosmolar hyperglycaemic state",
              questions: [64, 65],
            },
            {
              title: "Hyperthermia and hypothermia",
              children: [
                { title: "Hypothermia", questions: [66] },
                { title: "Malignant hyperthermia", questions: [67] },
              ],
            },
            {
              title: "Meningitis",
              questions: [68, 69],
            },
            {
              title: "Myocardial infarction",
              questions: [70, 71],
            },
            {
              title: "Necrotising fasciitis",
              questions: [72, 73],
            },
            {
              title: "Non-accidental injury",
              children: [
                { title: "Child abuse", questions: [74] },
                { title: "Adult abuse", questions: [75] },
              ],
            },
            {
              title: "Pancytopenia",
              questions: [76, 77],
            },
            {
              title: "Pneumonia",
              questions: [78, 79],
            },
            {
              title: "Pneumothorax",
              questions: [80, 81],
            },
            {
              title: "Postpartum haemorrhage",
              questions: [82, 83],
            },
            {
              title: "Pulmonary embolism",
              questions: [84, 85],
            },
            {
              title: "Raised intracranial pressure",
              questions: [86, 87],
            },
            {
              title: "Respiratory arrest",
              children: [
                { title: "Adult", questions: [88] },
                { title: "Child", questions: [89] },
              ],
            },
            {
              title: "Respiratory failure",
              children: [
                { title: "Respiratory failure", questions: [90] },
                { title: "Carbon monoxide poisoning", questions: [91] },
              ],
            },
            {
              title: "Self-harm",
              questions: [92, 93],
            },
            {
              title: "Sepsis",
              questions: [94, 95],
            },
            {
              title: "Spinal cord compression",
              questions: [96, 97],
            },
            {
              title: "Spinal cord injury",
              questions: [98, 99],
            },
            {
              title: "Stroke",
              questions: [100, 101],
            },
            {
              title: "Subarachnoid haemorrhage",
              questions: [102, 103],
            },
            {
              title: "Subdural haemorrhage",
              questions: [104, 105],
            },
            {
              title: "Substance use disorder",
              questions: [106, 107],
            },
            {
              title: "Testicular torsion",
              questions: [108, 109],
            },
            {
              title: "Toxic shock syndrome",
              questions: [110, 111],
            },
            {
              title: "Transfusion reactions",
              questions: [114, 115],
            },
            {
              title: "Unstable angina",
              questions: [116, 117],
            },
          ],
        },
        { title: "2. Cancer", progress: "0/45" },
        { title: "3. Cardiovascular", progress: "0/143" },
        { title: "4. Childhealth", progress: "0/54" },
        { title: "5. Clinical haematology", progress: "0/110" },
        { title: "6. Clinical imaging", progress: "0/45" },
        { title: "7. Dermatology", progress: "0/80" },
        { title: "8. Ear, nose and throat", progress: "0/78" },
        { title: "9. Endocrine and metabolic", progress: "0/84" },
        { title: "10. Gastrointestinal including liver", progress: "0/102" },
        { title: "11. General practice and primary healthcare", progress: "0/200" },
        { title: "12. Infection", progress: "0/102" },
        { title: "13. Medicine of older adult", progress: "0/102" },
        { title: "14. Mental health", progress: "0/102" },
        { title: "15. Musculoskeletal", progress: "0/102" },
        { title: "16. Nerusciences", progress: "0/102" },
        { title: "17. Obsetetrics and gynaecology", progress: "0/102" },
        { title: "18. Opthalmology", progress: "0/102" },
        { title: "19. Palliative and end of life care", progress: "0/102" },
        { title: "20. Perioperative medicine and anaesthesia", progress: "0/102" },
        { title: "21. Renal and Urlology", progress: "0/102" },
        { title: "22. Respiratory", progress: "0/102" },
        { title: "23. Sexual Health", progress: "0/102" },
        { title: "24. Surgery", progress: "0/102" },
        { title: "24. All areas and clinical practice", progress: "0/102" },
      ],
    };
  },

  created() {
    // Restore the section/viewMode the user was on when they navigated to a question
    try {
      const restoreSection = localStorage.getItem("questionListRestore_section");
      if (restoreSection) {
        if (restoreSection === "BY AREAS") {
          this.activeSection = "BY AREAS";
          this.viewMode = "areas";
        } else if (restoreSection === "ALPHABETICALLY") {
          this.activeSection = "ALPHABETICALLY";
          this.viewMode = "presentations";
        }
        localStorage.removeItem("questionListRestore_section");
      }
    } catch (e) {
      /* ignore */
    }

    fetchSectionLocks().then((locks) => {
      this.sectionLocks = locks;
    });

    get("/getsubjectclient").then((res) => {
      console.log("data", res.data);
      this.clinicalAreas = res.data.clinical;
      this.professionalKnowledge = res.data.professional;
    });

    get("/getmocks").then((res) => {
      this.mocksData = res.data.data || [];
    });

    get("/getpresentationconditionclient").then((res) => {
      console.log(res);

      this.PresentationsList = res.data.presentation;

      this.AlphaConditionsList = this.normalizeAlphaConditions(res.data.condition);
    });

    hydrateNoteUserState();

    get("/notesclient")
      .then((res) => {
        if (res.data.chaptersClinical) {
          this.notesClinicalAreas = this.transformNotesChapters(res.data.chaptersClinical);
        }
        if (res.data.chaptersProfessioanl) {
          this.notesProfessionalKnowledge = this.transformNotesChapters(res.data.chaptersProfessioanl);
        }
        rebuildNotesNumberRegistry([
          { items: this.notesClinicalAreas, listMode: "chapter" },
          { items: this.notesProfessionalKnowledge, listMode: "chapter" },
        ]);
      })
      .catch((error) => {
        console.error("Error fetching notes data:", error);
      });
  },

  mounted() {
    this._notesPrefsStorage = (ev) => {
      if (ev && ev.key && String(ev.key).indexOf("notesUserPrefs_") === 0) {
        invalidateNotesPrefsCache();
        this.notesReadRev += 1;
      }
    };
    window.addEventListener("storage", this._notesPrefsStorage);
  },

  activated() {
    this.notesReadRev += 1;
    fetchSectionLocks(true).then((locks) => {
      this.sectionLocks = locks;
    });
  },

  beforeDestroy() {
    if (this._notesPrefsStorage) {
      window.removeEventListener("storage", this._notesPrefsStorage);
    }
  },

  computed: {
    showAreaBreadcrumbs() {
      return this.viewMode === "areas";
    },
    showPresentationBreadcrumbs() {
      return this.viewMode === "presentations";
    },

    clinicalTotal() {
      return this.columnTotalFor(this.clinicalAreas);
    },
    professionalTotal() {
      return this.columnTotalFor(this.professionalKnowledge);
    },
    presentationsTotal() {
      return this.columnTotalFor(this.PresentationsList);
    },
    conditionsTotal() {
      return this.columnTotalFor(this.AlphaConditionsList);
    },

    globalTotalQuestions() {
      return (
        this.clinicalAreas.reduce((s, i) => s + (parseInt(i.questions_count) || 0), 0) +
        this.professionalKnowledge.reduce(
          (s, i) => s + (parseInt(i.questions_count) || 0),
          0
        )
      );
    },
    globalCorrect() {
      return (
        this.clinicalAreas.reduce((s, i) => s + (parseInt(i.correct_count) || 0), 0) +
        this.professionalKnowledge.reduce(
          (s, i) => s + (parseInt(i.correct_count) || 0),
          0
        )
      );
    },
    globalAttempted() {
      return (
        this.clinicalAreas.reduce((s, i) => s + (parseInt(i.attempted_count) || 0), 0) +
        this.professionalKnowledge.reduce(
          (s, i) => s + (parseInt(i.attempted_count) || 0),
          0
        )
      );
    },
    globalScorePercent() {
      if (!this.globalTotalQuestions) return 0;
      return Math.round((this.globalCorrect / this.globalTotalQuestions) * 100);
    },

    /** Attempted / total, for Progress label on the Questions card (matches Notes-style “Progress” bar) */
    globalProgressPercent() {
      if (!this.globalTotalQuestions) return 0;
      return Math.round((this.globalAttempted / this.globalTotalQuestions) * 100);
    },

    mocksProgressPercent() {
      return mocksAggregateProgressPercent(this.mocksData);
    },

    questionsSidebarDetail() {
      if (this.questionsSidebarScoreMode) {
        return `${this.globalCorrect}/${this.globalTotalQuestions}`;
      }
      return `${this.globalAttempted}/${this.globalTotalQuestions}`;
    },

    mocksProgressDetail() {
      const t = mocksAggregateTotals(this.mocksData);
      return `${t.totalAttempted}/${t.totalQuestions}`;
    },

    notesSidebarProgress() {
      void this.notesReadRev;
      void this.notesClinicalAreas.length;
      void this.notesProfessionalKnowledge.length;
      return notesProgressStats(this.$store, [
        ...this.notesClinicalAreas,
        ...this.notesProfessionalKnowledge,
      ]);
    },

    notesProgressPercent() {
      return this.notesSidebarProgress.percent;
    },

    notesProgressDetail() {
      const { read, total } = this.notesSidebarProgress;
      return `${read}/${total}`;
    },
  },
  methods: {
    normalizeAlphaConditions(list) {
      return (list || []).map((condition) => {
        const children = condition.children || condition.sublists || [];
        return {
          ...condition,
          children: children.map((child) => ({
            ...child,
            children: child.children || child.sublists || [],
          })),
        };
      });
    },

    transformNotesChapters(chapters) {
      if (!chapters || !Array.isArray(chapters)) return [];

      return chapters.map((chapter) => {
        const transformedChapter = {
          id: chapter.id || null,
          title: chapter.title || "",
          index_number: chapter.index_number || null,
        };

        if (chapter.notes && Array.isArray(chapter.notes) && chapter.notes.length > 0) {
          transformedChapter.children = chapter.notes.map((note) => {
            const transformedNote = {
              id: note.id || null,
              title: note.title || "",
              index_number: note.index_number || null,
              number: note.number || null,
            };

            if (note.sub_notes && Array.isArray(note.sub_notes) && note.sub_notes.length > 0) {
              transformedNote.children = note.sub_notes.map((subNote) => ({
                id: subNote.id || null,
                title: subNote.title || "",
                index_number: subNote.index_number || null,
                number: subNote.number || null,
              }));
            }

            return transformedNote;
          });
        }

        return transformedChapter;
      });
    },

    columnTotalFor(items) {
      const list = items || [];
      const total = list.reduce((s, i) => s + (parseInt(i.questions_count, 10) || 0), 0);
      const numerator = this.questionsSidebarScoreMode
        ? list.reduce((s, i) => s + (parseInt(i.correct_count, 10) || 0), 0)
        : list.reduce((s, i) => s + (parseInt(i.attempted_count, 10) || 0), 0);
      return `${numerator}/${total}`;
    },
    toggleQuestionsSidebarScoreMode() {
      this.questionsSidebarScoreMode = !this.questionsSidebarScoreMode;
    },
    onQuestionsSidebarClick() {
      if (this.isSectionLocked("questions")) {
        this.openSubscribePopup("questions");
        return;
      }
      this.toggleQuestionsSidebarScoreMode();
    },
    isSectionLocked(key) {
      return !!(this.sectionLocks && this.sectionLocks[key]);
    },
    openSubscribePopup(sectionKey) {
      this.subscribeMessage = subscribeSectionMessage(sectionKey);
      this.showSubscribePopup = true;
    },
    toggleLeftPanel() {
      this.leftPanelCollapsed = !this.leftPanelCollapsed;
    },
    openExitAlert(e) {
      if (e === "Notes" && this.isSectionLocked("notes")) {
        this.openSubscribePopup("notes");
        return;
      }
      if (e === "Mocks" && this.isSectionLocked("mocks")) {
        this.openSubscribePopup("mocks");
        return;
      }
      if ((e === "Question" || e === "Questions") && this.isSectionLocked("questions")) {
        this.openSubscribePopup("questions");
        return;
      }
      if (e === "Notes") {
        this.$router.push("/noteslistselection");
        return;
      }
      if (e === "Mocks") {
        this.$router.push("/mocksection");
        return;
      }
      this.$router.push("/mlalistselection");
    },
    confirmExit() {
      this.showExitPopup = false;
      if (this.exitpage == "Notes") {
        if (this.isSectionLocked("notes")) return;
        this.$router.push("/noteslistselection");
      } else {
        if (this.isSectionLocked("mocks")) return;
        this.$router.push("/mocksection");
      }
    },
    openSearch(payload) {
      const q = (payload && payload.q) || String(this.searchQuery || "").trim();
      if (!q) return;
      const categories = (payload && payload.categories) || [];
      this.$router.push({
        path: "/search",
        query: {
          from: this.$route.fullPath,
          q,
          source: "questions",
          question_scope: this.viewMode === "presentations" ? "presentations" : "areas",
          ...(categories.length ? { categories: categories.join(",") } : {}),
        },
      });
    },
    AreaCondition() {
      this.activeSubSection = "ByAreaCondition";
    },
    setViewMode(mode) {
      this.viewMode = mode;
      console.log("mode", mode);
      // Set the default tab shown when switching
      // this.activeSection = 'MLA CONTENT MAP';
      if (mode == "areas") {
        this.activeSection = "BY AREAS";
      } else {
        this.activeSection = "ALPHABETICALLY";
      }
    },
    handleSortChange(option) {
      if (option === "alphabetically") {
        this.activeSection = "ALPHABETICALLY";
      } else if (option === "byareas") {
        this.activeSection = "BY AREAS PRESENTATION";
        this.activeSubSection = "";
      }
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.popup {
  background: #fff;
  padding: 20px 25px;
  border-radius: 8px;
  width: 320px;
  text-align: center;
}

.actions {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
}

button {
  padding: 8px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.yes {
  background: #e53935;
  color: white;
}

.no {
  background: #ccc;
}

.exit-text {
  color: #1976d2;
  cursor: pointer;
  text-decoration: underline;
}

.breadcrumb-wrapper {
  height: 40px;
  overflow: hidden;
  transition: all 0.6s ease;
  transform: translateY(100%);
  opacity: 0;
}

/* When visible, slide down smoothly */
.breadcrumb-wrapper.visible {
  transform: translateY(0);
  opacity: 1;
}

/* Breadcrumb content style */
.breadcrumb {
  display: flex;
  align-items: center;
  height: 40px;
}

.listing {
  width: 100%;
  display: flex;
  gap: 20px;
}

.mla-list-layout {
  position: relative;
  display: flex;
  align-items: stretch;
  min-height: calc(100vh - 150px);
  transition: gap 0.35s ease;
}

.mla-list-layout--sidebar-collapsed {
  gap: 8px;
}

.mlalist-left-section {
  position: relative;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  transition: flex-basis 0.35s ease, max-width 0.35s ease;
}

.mlalist-left-full {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1 1 auto;
  height: 100%;
  min-height: 100%;
  transition: opacity 0.25s ease, visibility 0.25s ease;
}

.mlalist-left-full--hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  overflow: hidden;
}

.mla-list-layout--sidebar-collapsed .mlalist-left-section {
  flex: 0 0 32px !important;
  max-width: 32px;
  min-width: 32px;
}

.mlalist-right-section {
  position: relative;
  overflow: visible;
  align-self: stretch;
  display: flex;
  transition: flex-basis 0.35s ease, max-width 0.35s ease;
}

.mlalist-right-section .listing {
  flex: 1 1 auto;
  width: 100%;
  align-items: stretch;
}

.mla-list-layout--sidebar-collapsed .mlalist-right-section {
  flex: 1 1 calc(100% - 40px) !important;
  max-width: calc(100% - 40px);
}

/* Expanded: original triangular tab at top of divider */
.mla-sidebar-toggle {
  position: absolute;
  top: 18px;
  left: -30px;
  z-index: 25;
  width: 14px;
  height: 56px;
  padding: 0 8px 0 0;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  box-sizing: content-box;
}

.mla-sidebar-toggle-tab {
  display: block;
  width: 16px;
  height: 32px;
  overflow: visible;
  filter: drop-shadow(-4px 0 7px rgba(106, 184, 234, 0.45));
  transition: filter 0.35s ease;
}

.mla-sidebar-toggle-tab path {
  transition: fill 0.2s ease;
}

.mla-sidebar-toggle:hover .mla-sidebar-toggle-tab {
  filter: drop-shadow(-5px 0 9px rgba(106, 184, 234, 0.55));
}

.mla-sidebar-toggle:hover .mla-sidebar-toggle-tab path {
  fill: url(#mlaSidebarToggleGradHover);
}

.mla-sidebar-toggle-tab--expand {
  filter: drop-shadow(4px 0 7px rgba(106, 184, 234, 0.45));
}

.mla-sidebar-toggle-tab--expand path {
  fill: #fff;
}

.mla-collapsed-rail-toggle:hover .mla-sidebar-toggle-tab--expand {
  filter: drop-shadow(5px 0 9px rgba(106, 184, 234, 0.55));
}

.mla-collapsed-rail-toggle:hover .mla-sidebar-toggle-tab--expand path {
  fill: url(#mlaSidebarToggleGradHover);
}

/* Collapsed rail strip */
.mla-collapsed-rail {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 20px;
  min-height: 100%;
  height: 100%;
  flex-shrink: 0;
}

.mla-collapsed-rail-toggle {
  position: absolute;
  top: 18px;
  left: -3px;
  z-index: 10;
  width: 10px;
  height: 36px;
  padding: 0 0 0 8px;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  box-sizing: content-box;
}

.mla-collapsed-rail-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 20px;
  min-height: 100%;
  background: #88c7ef;
  overflow: hidden;
  border-radius: 5px;
}

.mla-collapsed-rail-segment {
  flex-shrink: 0;
  width: 100%;
}

.mla-collapsed-rail-segment--map {
  flex: 1 1 auto;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 70px;
  background: linear-gradient(to top, #b1d8ff 20%, #94caff 45%, #1a90ff 100%);

  min-height: 50px;
}

.mla-collapsed-rail-segment--questions {
  height: 44px;
  background: #1a90ff;
  margin-top: auto;
}

.mla-collapsed-rail-segment--notes {
  height: 44px;
  background: #f59c00;
}

.mla-collapsed-rail-segment--mocks {
  height: 44px;
  background: #ed1c24;
}

.mla-collapsed-rail-segment--gap {
  height: 8px;
  background: #d7ebff;
}

.mla-collapsed-rail-label {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  color: #fff;
  font-size: 10px;
  font-family: Helvetica, sans-serif;
  letter-spacing: 0.3px;
  white-space: nowrap;
  user-select: none;
  pointer-events: none;
  line-height: 1;
}

.areas-presentation-condition {
  width: 100%;
  border: 0.75px solid #d0d2d3;
  padding: 13px 10px;
  border-radius: 20px;
}
.breadcrumb {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  padding: 10px 0 20px;
  justify-content: center;
}

.breadcrumb-item {
  padding: 3px 10px;
  color: white;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 300;
  cursor: pointer;
  background: #bbbdbf;
}

.breadcrumb-item.active {
  background-color: #1a90ff;
}

.breadcrumb-item.inactive {
  background-color: #bbbdbf;
}

.breadcrumb-arrow {
  padding: 0 6px;
  color: #bbbdbf;
  font-size: 16px;
}

.mla-question-box {
  background: #1a90ff;
  border: 1px solid #0276ba;
  margin: 30px 0px 0px 0px;
  padding: 0;
  border-radius: 16px;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  overflow: hidden;
  border: none;
}

.mla-question-box .section-card-body {
  flex: 1;
  min-width: 0;
  padding: 5px 6px 2px;
  box-sizing: border-box;
}

.mla-question-box .cardbottom-shadow img {
  left: 50%;
  transform: translate(-50%);
  bottom: -27px;
  width: 350px;
}

.mla-question-box h4 {
  font-size: 22px;
  color: #fff;
  text-transform: uppercase;
  padding: 0 0 6px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}

.mla-question-box h4 img {
  width: 27px;
  height: 27px;
  object-fit: contain;
}

.score-detail {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.85);
  text-align: right;
  margin-top: 3px;
  font-family: HelveticaBoldcont, sans-serif;
}

.mla-note-box {
  background-color: #f59c00;
  border-color: #f59c00;
  border: none;
}

.mla-mock-box {
  background-color: #ed1c24;
  border-color: #ed1c24;
  border: none;
}

.mocks-summary-toggle {
  cursor: pointer;
  user-select: none;
}

/* Locked sidebar card: same height feel, title centered, no progress */
.mla-question-box.is-section-locked {
  min-height: 70px;
}

.mla-question-box.is-section-locked .section-card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 70px;
}

.mla-question-box.is-section-locked h4 {
  padding: 0;
}

/* Short viewports: keep panels equal height; scroll sidebar content if needed */
@media (max-height: 760px) {
  .mla-list-layout {
    min-height: calc(100vh - 120px);
  }

  .mlalist-left-full {
    justify-content: flex-start;
    gap: 14px;
    overflow-y: auto;
    overscroll-behavior: contain;
    padding-bottom: 8px;
  }

  .mlalist-left-full .mla-question-box {
    margin-top: 16px;
  }

  .mlalist-left-full .mla-question-box:first-child {
    margin-top: 12px;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1220px;
  }
}
</style>
